import React from 'react';
import Lottie from 'react-lottie';

import animationData from '../../lottie/loading-animation.json';

type LoadingProps = { width?: number; height?: number };

const Loading = ({ width = 250, height = 250 }: LoadingProps): JSX.Element => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return <Lottie options={defaultOptions} height={height} width={width} />;
};

export default Loading;
